import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DcReturnViewSingle = () => {
  useAuthRedirect();
    const {dcNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);

  const canView = hasPermission("D.C Returns", "view");


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dcReturn_detailsHeader?dcNo=${dcNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                dcNumber: items[0].dcreturnheader_number,
                branch: items[0].branchCode,
                dcDate: items[0].dcreturnheader_date,
                type: items[0].dcreturnheader_type,
                scode: items[0].dcreturnheader_supplierCode,
                sName: items[0].dcreturnheader_supplierName,
                ourRefNo: items[0].dcreturnheader_OurDcNumber,
                ourRefDate: items[0].dcreturnheader_OurDcDate,
                yourRefNo: items[0].dcreturnheader_yourDcNumber,
                yourRefDate: items[0].dcreturnheader_yourDcDate,
                pack: items[0].dcreturnheader_noofPacks,
                vno: items[0].dcreturnheader_vehicleNumber,
                remarks: items[0].dcreturnheader_remarks,
                address: items[0].dcreturnheader_txtAddress,
                city: items[0].dcreturnheader_txtCity,
                pincode: items[0].dcreturnheader_txtPincode,
                phone: items[0].dcreturnheader_txtPhone,
                email: items[0].dcreturnheader_txtMobile,
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [dcNo, branch]); 


const [loading, setLoading] = useState(true);

useEffect(() => {
  setLoading(true); // start loading
  axios
    .get(`https://rfs2.infraconsoft.net.in/api/dcReturns_bottomDetails?dcNo=${dcNo}&branch=${branch}`)
    .then((response) => {
      setData(response.data.bottomDetails || []);
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    })
    .finally(() => {
      setLoading(false); // stop loading
    });
}, [dcNo, branch]);

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                                                  <h2 className="add-txt">D.C. Returns - View</h2>
                                                  <Link to='/inventory/dcReturnView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                  </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>D.C Return No :</label>
                <input type="text" name="indentNo" value={header.dcNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="date"
  value={
    header.dcDate && !isNaN(Date.parse(header.dcDate))
      ? new Date(header.dcDate).toISOString().split("T")[0]
      : ""
  }
  readOnly
/>

        
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Type :</label>
                <input type="text" name="type" value={header.type} readOnly />
              </div>
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="branch" value={header.branch} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" value={header.scode} readOnly/>
              </div>

              <div className="form-group">
                <label>Supplier Name:</label>
                <input type="text"value={header.sName} readOnly />
              </div>
            </div>




            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" value={header.yourRefNo} readOnly/>
              </div>

              <div className="form-group">
                <label>Your Ref Date :</label>
                <input
  type="date"
  value={
    header.yourRefDate && !isNaN(Date.parse(header.yourRefDate))
      ? new Date(header.yourRefDate).toISOString().split("T")[0]
      : ""
  }
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Our Ref No :</label>
                <input type="text" value={header.ourRefNo} readOnly/>
              </div>

              <div className="form-group">
                <label>Our Ref Date :</label>
                  <input
  type="date"
  value={
    header.ourRefDate && !isNaN(Date.parse(header.ourRefDate))
      ? new Date(header.ourRefDate).toISOString().split("T")[0]
      : ""
  }
  readOnly
/>
            
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle No :</label>
                <input type="text" value={header.vno} readOnly/>
              </div>

              <div className="form-group">
                <label>No.Of Packs:</label>
                <input type="text" value={header.pack} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address :</label>
                <input type="text" value={header.address} readOnly/>
              </div>

              <div className="form-group">
                <label>Email:</label>
                <input type="text" value={header.email} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" value={header.city} readOnly/>
              </div>

              <div className="form-group">
                <label>Pincode :</label>
                <input type="text" name="pincode"value={header.pincode} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone :</label>
                <input type="text" value={header.phone} readOnly/>
              </div>

              <div className="form-group">
                <label>Remarks :</label>
                <input type="text"value={header.remarks} readOnly />
              </div>
            </div>

            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Pending Qty</th>
                    <th>Reached Qty</th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", fontWeight: "bold" }}>
        Loading...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.dcreturndetail_itemcode}</td>
        <td>{item.itemmaster_drawingNumber}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemmaster_uom}</td>
        <td>{item.dcreturndetail_DcPendingQuantity}</td>
        <td>{item.dcreturndetail_Quantity}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default DcReturnViewSingle;
